  // src/hooks/useSession.js
  import { useEffect } from 'react';
  import { useNavigate } from 'react-router-dom';
  import api from '../api/index';

  /** Локальный "Запомнить меня" без импорта из utils */
  const REMEMBER_KEY = 'ses_remember_me';
  function getRememberMeLocal() {
    try { return localStorage.getItem(REMEMBER_KEY) === '1'; } catch { return false; }
  }

  /**
   * Следит за валидностью сессии:
   *   • при монтировании
   *   • периодически (интервал зависит от "Запомнить меня")
   *   • при возврате фокуса во вкладку
   */
  export default function useSession(pingEvery) {
    const navigate = useNavigate();
    const remember = getRememberMeLocal();
    const intervalMs = Number.isFinite(pingEvery)
      ? pingEvery
      : (remember ? 5 * 60_000 : 60_000); // 5 мин vs 1 мин

    const ensureSession = async () => {
      try {
        if (document.visibilityState === 'hidden') return;
        await api.get('/me'); // интерцепторы сами рефрешнут
        return;
      } catch (err) {
        if (err?.response?.status !== 401) return;
      }
      try {
        await api.get('/me');
      } catch (err2) {
        if (err2?.response?.status === 401) {
          navigate('/login', { replace: true });
        }
      }
    };

    useEffect(() => {
      ensureSession();
      const id = setInterval(ensureSession, Math.max(30_000, intervalMs));
      const onFocus = () => (document.visibilityState === 'visible') && ensureSession();
      window.addEventListener('focus', onFocus);
      window.addEventListener('visibilitychange', onFocus);
      return () => {
        clearInterval(id);
        window.removeEventListener('focus', onFocus);
        window.removeEventListener('visibilitychange', onFocus);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [intervalMs, remember]);
  }
